import {Component} from '@angular/core';

@Component({
    selector: '[app-table-header-separator]',
    templateUrl: './table-header-separator.component.html',
    styleUrls: ['./table-header-separator.component.scss'],
    standalone: false
})
export class TableHeaderSeparatorComponent {
}
